module.exports = __webpack_public_path__ + "img/menu_rotinas_icon.4472db80.png";